export default "__VITE_ASSET__Si1xtCOB__"